/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TotalInputs */

const th_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รวม`)
};

const en_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const ja_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合計`)
};

const zh_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合计`)
};

const es_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const pt_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const id_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const fr_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const tl_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kabuuan`)
};

const vi_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng`)
};

const ko_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`합계`)
};

const de_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamt`)
};

const ru_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всего`)
};

const tr_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toplam`)
};

const it_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale`)
};

const pl_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Razem`)
};

const uk_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разом`)
};

const hi_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुल`)
};

const ar_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المجموع`)
};

const ms_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah`)
};

const bn_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মোট`)
};

const zh_tw2_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`總計`)
};

const zh_hk2_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`總計`)
};

const ur_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کل`)
};

const fa_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجموع`)
};

const sw_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumla`)
};

const nl_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totaal`)
};

/**
* | output |
* | --- |
* | "Total" |
*
* @param {TotalInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const total = /** @type {((inputs?: TotalInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TotalInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_total(inputs)
	if (locale === "ja") return ja_total(inputs)
	if (locale === "zh") return zh_total(inputs)
	if (locale === "es") return es_total(inputs)
	if (locale === "pt") return pt_total(inputs)
	if (locale === "id") return id_total(inputs)
	if (locale === "fr") return fr_total(inputs)
	if (locale === "tl") return tl_total(inputs)
	if (locale === "vi") return vi_total(inputs)
	if (locale === "ko") return ko_total(inputs)
	if (locale === "de") return de_total(inputs)
	if (locale === "ru") return ru_total(inputs)
	if (locale === "tr") return tr_total(inputs)
	if (locale === "it") return it_total(inputs)
	if (locale === "pl") return pl_total(inputs)
	if (locale === "uk") return uk_total(inputs)
	if (locale === "hi") return hi_total(inputs)
	if (locale === "ar") return ar_total(inputs)
	if (locale === "ms") return ms_total(inputs)
	if (locale === "bn") return bn_total(inputs)
	if (locale === "zh-TW") return zh_tw2_total(inputs)
	if (locale === "zh-HK") return zh_hk2_total(inputs)
	if (locale === "ur") return ur_total(inputs)
	if (locale === "fa") return fa_total(inputs)
	if (locale === "sw") return sw_total(inputs)
	if (locale === "nl") return nl_total(inputs)
	return en_total(inputs)
});